import client from './api-client';

export const getConfiguracionForm28 = async(query) => {
    try {
        
        const response = await client.getSelect(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form28: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboZonas = async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboZonas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosGrilla = async(query) => {
    try {
        
        const response = await client.getSelect(`responsables/xzona?q=${query}`);  
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGrilla: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosGestion = async(query) => {
    try {
        
        const response = await client.getImplicado(`getion-implicado?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGestionCaso: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const postReasignarResponsable= async(newClient) => {
    try {
        const response = await client.postSelect('caso/asigna-responsable',newClient)      

        if (response.status === 200 && response.data.code === 1) {
            return {respuestaAsignar: response.data};
        } else {
            return {respuestaAsignar: response.data};
        }
        
    } catch(error){
        throw error;
        console.log(error)
    }
}
export const getTipoNotificaSiniestro = async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                tiposNotificaSiniestro: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}